<template>
	<div class="page page-bg-render" data-name="guest-pqat-main">
		<div class="page-content infinite-scroll-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					<span>인적성평가</span>
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>

			<div class="block-title padding-top">
				인적성평가 응시정보 입력
			</div>

			<div class="list media-list">
				<ul>
					<li>
						<div class="item-content item-input item-input-with-value">
							<div class="item-inner">
								<div class="item-input-wrap">
									<input
										name="code"
										ref="code"
										type="text"
										placeholder="인적성평가 응시코드"
										class="input-with-value"
										v-model="code"
										@keyup.enter="$refs.userName.focus()"
									/>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="item-content item-input item-input-with-value">
							<div class="item-inner">
								<div class="item-input-wrap">
									<input
										name="userName"
										ref="userName"
										type="text"
										placeholder="응시자 이름"
										class="input-with-value"
										v-model="userName"
										@keyup.enter="checkupResult"
									/>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<div class="block">
				<div class="row">
					<div class="left">
						<button class="button button-fill" v-on:click="addPQATClick">새로 응시하기</button>
					</div>
					<div class="right">
						<button class="button button-fill" v-on:click="checkupResult">응시결과 확인</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';

	import store from '../../../js/store';

	import MODULE from '../../../js/common/module';
	import AUTH from '../../../js/common/auth.js';
	import PAGES from '../../../js/pages';
	import API from '../../../js/common/api.js';
	import CONST from '../../../js/common/constant';
	
	export default {
		data() {
			return {
				code: undefined,
				userName: undefined,
			}
		},
		mounted() {
			var _this = this;
			
		},
		methods: {
			addPQATClick() {
				MODULE.DialogBox.message("guest-pqat-apply.vue 호출로 응시 시작.");
			},
			checkupResult() {
				MODULE.DialogBox.message("응시코드와 이름으로 응시결과 확인 : 응시완료");
			},
			addContentsReportClick() {
				var _this = this;

				var url = PAGES.SUB_CONTENTS_REPORT;
				var param = {
					csKey: undefined,
					code: undefined
				}

				PAGES.popPage(url, param);
			},
			toDate(datetime) {
				return moment(datetime).format("YYYY-MM-DD HH:mm");
			},
			toCSType(csTypeId) {
				return CONST.csType[csTypeId].name;
			},
			toContent(content) {
				return (MODULE.Util.isEmpty(content) ? "오류 설명 없음." : content);
			}
			
		}
	}

</script>